import { Button, Center } from "@mantine/core";
import { modals } from "@mantine/modals";

import SRD_Form from "components/Form";
import React, { useState, useEffect } from "react";

import { useNavigate } from "react-router-dom";
import { useRecoilState } from "recoil";
import { userState } from "pages/Login/atom/userState";
import { groupListState } from "components/Form/atom/groupListState";

import {
  getSellUser,
  updateUserInfo,
} from "pages/Admin/User/apis/adminUserApis";
import { levelListState } from "components/Form/atom/levelListState";

function MyPageForm() {
  const navigate = useNavigate();

  const [user, setUser] = useRecoilState(userState);
  const [groupList, setGroupList] = useRecoilState(groupListState);
  const [levelList, setLevelList] = useRecoilState(levelListState);

  const [defaultValues, setDefaultValues] = useState();

  useEffect(() => {
    getSellUser(user.user_id).then((res) => setDefaultValues(res));
  }, []);

  const fields = [
    {
      key: "user_id",
      name: "아이디",
      type: "id",
      disabled: true,
    },
    {
      key: "password",
      name: "비밀번호",
      type: "password",
    },
    {
      key: "confirm_password",
      name: "비밀번호 확인",
      type: "confirm_password",
    },
    {
      key: "fn_name",
      name: "이름",
      type: "text",
    },
    {
      key: "fn_group_id",
      name: "소속그룹",
      type: "select",
      options: groupList,
      disabled: true,
    },
    {
      key: "fn_level",
      name: "사용자권한",
      type: "select",
      options: levelList,
      disabled: true,
    },
    {
      key: "fn_mobile_nbr",
      name: "전화번호",
      type: "phone_number",
    },
    {
      key: "fn_address",
      name: "주소",
      type: "text",
    },
  ];

  const onSubmit = (e) => {
    modals.openConfirmModal({
      title: "수정",
      children: <Center>수정 하시겠습니까?</Center>,
      centered: true,
      zIndex: 2000,
      labels: { confirm: "수정", cancel: "취소" },
      onConfirm: () => {
        updateUserInfo(e);
   //     navigate("/home");
        navigate(-1);
      },
    });
  };

  const SubmitButton = () => {
    return (
      <Center style={{ marginTop: "1rem" }}>
        <Button type="submit">수정</Button>
      </Center>
    );
  };
  return (
    <SRD_Form
      fields={fields}
      onSubmit={onSubmit}
      submitButton={<SubmitButton />}
      defaultValues={defaultValues}
    />
  );
}

export default MyPageForm;
